import React, { createContext, useState } from 'react';

export const FleetContext = createContext();

export  const FleetProvider=({ children }) =>{
    const [fleets,setFleets]=useState({})
    return (
        <FleetContext.Provider value={{ fleets, setFleets}}>
            {children}
        </FleetContext.Provider>
    );
}
